import {
  getOtherWellnessActionText,
  isOtherWellnessAction,
} from "../../../utils/wellnessActions";

// Word alerts from students who have data sharing turned off.
//
// The server returns these with `sharingOff: true`, a minimal student (id,
// name, email) and, from the check-in, only the message that triggered the
// alert and its date. They're shown in their own panel and
// deliberately never open the student detail view, which would load the
// student's wellness history - the thing their data sharing setting keeps
// private.

export function selectSharingOffWordAlerts(alertGroups) {
  if (!Array.isArray(alertGroups)) return [];

  return alertGroups
    .filter((group) => group?.sharingOff === true)
    .flatMap((group) =>
      (group.alerts || [])
        .filter((alert) => alert?.type?.kind === "word")
        .map((alert) => ({
          alertId: String(alert._id),
          studentName:
            group.student?.displayName?.trim() ||
            group.student?.email ||
            "A student",
          words: Array.isArray(alert.type.value)
            ? alert.type.value
            : String(alert.type.value || "")
                .split(/[\s,]+/)
                .filter(Boolean),
          message: messageFrom(alert.wellness),
          createdAt: alert.createdAt,
          read: Boolean(alert.read),
          raw: alert,
        })),
    )
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

// The free-text the student wrote, as the existing alert card shows it.
function messageFrom(wellness) {
  const raw = String(wellness?.action || "").trim();
  if (!raw) return "";
  const text = isOtherWellnessAction(raw)
    ? getOtherWellnessActionText(raw) || raw
    : raw;
  return text.charAt(0).toUpperCase() + text.slice(1);
}
